import React from 'react'
import {useSelector} from 'react-redux'
import View from './view'
import {selectMember} from '../../../redux/members'

const SubscriptionsMatrix = () => {
  const member = useSelector(selectMember)

  return <View isCGAAdmin={member?.groupId === 91 && member?.isGroupAdmin} />
}

export default SubscriptionsMatrix
